<div class="row not-found">
  <div class="col-md-12">
    <nb-card>
      <nb-card-body>
        <div class="flex-centered col-xl-10 col-lg-6 col-md-10 col-sm-12">
          <h2 class="title">Halaman Tidak Ditemukan</h2>
          <p class="sub-title">Halaman yang ada cari tidak ditemukan</p>
          <button nbButton fullWidth (click)="goBack()" type="button" class="home-button">
            Kembali
          </button>
        </div>
      </nb-card-body>
    </nb-card>
  </div>
</div>
